import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { OnlineContext } from "./_context/OnlineContext";
import styles from "./OnlineProvider.module.css";

import { Paper } from "@/components/atoms/Paper/Paper";
import { Text } from "@/components/atoms/Text";
import { Snackbar } from "@/components/molecules/Snackbar";
import { useOnline } from "@/providers/_hooks/useOnline";

interface Props {
  children: ReactNode;
}

export const OnlineProvider = ({ children }: Props) => {
  const onlineState = useOnline();

  return (
    <OnlineContext value={onlineState}>
      {children}
      <CustomSnackbar
        open={onlineState.status === "offline"}
        message="connectionStatus.offlineDescription"
      />
      <CustomSnackbar
        open={onlineState.status === "recovering"}
        message="connectionStatus.recoveringDescription"
      />
      <CustomSnackbar
        open={onlineState.status === "recovered"}
        message="connectionStatus.recoveredDescription"
      />
    </OnlineContext>
  );
};

const CustomSnackbar = ({
  open,
  message,
}: {
  open: boolean | undefined;
  message: string;
}) => {
  const { t } = useTranslation();
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Paper variant="elevation" elevation={6}>
        <div className={styles.snackbarContent}>
          <Text
            variant="body2"
            color="on-primary"
            as="p"
            className={styles.snackbarText}
          >
            {t(message)}
          </Text>
        </div>
      </Paper>
    </Snackbar>
  );
};
